module.exports = __webpack_public_path__ + "img/tints.aa5b7db8.jpg";